import styled from 'styled-components/macro'

import { Text } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

const Wrapper = styled(Text)`
  background-color: ${getToken('color-neutral-darker')};
  padding: ${getToken('space-xs')} ${getToken('space-s')};
  font-size: ${getToken('font-size-5')};
  text-transform: uppercase;
`

/**
 * @param {object} props
 * @param {string} [props.name]
 * @returns {JSX.Element | null}
 */
function OfferedBy({ name }) {
  if (!name) {
    return null
  }

  return (
    <Wrapper as="div" variant="body" color="color-neutral-white">
      {name} Sent you this load!
    </Wrapper>
  )
}

export { OfferedBy }
